const state = () => ({
  current: null,
});

const getters = {
  currentNotification(state) {
    return state.current;
  },
};

const mutations = {
  SET_NOTIFICATION(state, payload) {
    state.current = payload;
  },
  CLEAR_NOTIFICATION(state) {
    state.current = null;
  },
};

const actions = {
  showError({ commit }, normalizedError) {
    if (!normalizedError) return;

    commit("SET_NOTIFICATION", {
      type: "error",
      i18nKey: normalizedError.i18nKey || "errors.generic",
      i18nParams: normalizedError.i18nParams || {},
      timeout: 5000,
    });
  },
  showSuccess({ commit }, payload) {
    if (!payload || !payload.i18nKey) return;

    commit("SET_NOTIFICATION", {
      type: "success",
      i18nKey: payload.i18nKey,
      i18nParams: payload.i18nParams || {},
      timeout: payload.timeout || 3500,
    });
  },
  clear({ commit }) {
    commit("CLEAR_NOTIFICATION");
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};

